import { Role } from '@guiker/permissions'

import { LeaseRoleNames } from '../../entity'
import { LeaseActions } from '../lease-actions'

export const LessorRole: Role = {
  name: LeaseRoleNames.LESSOR,
  permissions: [{ action: LeaseActions.SignLeaseAsLessor }, { action: LeaseActions.ViewLease }],
}
